import { createCrudActions } from "../utils/crudGenerator";

const formatZonecategories = (data) => {
  if (!data) {
    return [];
  }

  const formatItem = (item) => ({
    ...item,
    label: item.name || item.label || item._id,
    value: item._id,
  });

  if (Array.isArray(data)) {
    return data.map(formatItem);
  }

  return formatItem(data);
};

export const {
  fetch: fetchZonecategories,
  create: createZonecategory,
  update: updateZonecategory,
  delete: deleteZonecategories,
} = createCrudActions("zonecategory", "Categoría Zona", formatZonecategories);
